angular.module('zc.commonApi')


.factory "CampaignSegment", ($resource, $q, BaseProjectCrudService, Api, campaignSegmentResponseTransformer, campaignSegmentRequestTransformer) ->
  class CampaignSegment extends BaseProjectCrudService
    toZcRuleCollection: (name, collection) ->
      ret = {}
      for f, v of collection
        continue if !f or f == 'apikey'
        column = "#{name}##{f}"
        if !(_.isBoolean(v) or _.isPlainObject(v)) and /^(is_)|(syncd)/.test(f)
          # TODO: DANGER!! "is_..." field MUST BE boolean or object IN IMPLICIT.
          #       I project that converting to t/f is needness
          #       because mongoose will convert automatically without aggregate().
          throw {message: "#{column} should be boolean or object "}
        if _.isPlainObject(v) and v['$not'] and v['$not']['$regex']
          throw {message: "{$not: {$regex: 'xxx'}} is not allowed in MongoDB"}
        ret[column] = v
      ret

    toZcRule: (campaignSegment) ->
      jsonObj = {}
      try
        if campaignSegment.visitor
          eval "var visitorQuery = #{campaignSegment.visitor};"
          _.assignIn jsonObj, @toZcRuleCollection('Visitor', visitorQuery)
        if campaignSegment.session
          eval "var sessionQuery = #{campaignSegment.session};"
          _.assignIn jsonObj, @toZcRuleCollection('Session', sessionQuery)
        campaignSegment.raw = JSON.stringify
          visitor: campaignSegment.visitor
          session: campaignSegment.session
        campaignSegment.message = ''
      catch err
        campaignSegment.message = err.message
        null
      jsonObj

    checkZcRule: (campaignSegment) ->
      return if !campaignSegment
      campaignSegment.rule = @toZcRule(campaignSegment)
      campaignSegment.ruleView = ''
      if campaignSegment.rule
        for f, v of campaignSegment.rule
          campaignSegment.ruleView += "#{f}, #{JSON.stringify(v)}\n"
        campaignSegment.json = JSON.stringify campaignSegment.rule

    getMongoQuery: (campaignSegment) ->
      # Need to use deep copy (merge) so that conditions_json
      # insides don't break
      segment = _.merge {}, campaignSegment
      if segment.conditions_json.limit_to_landing_page_types &&
          (_.isEmpty(segment.conditions_json.limit_to_landing_page_types) ||
          segment.conditions_json.limit_to_landing_page_types[0] == "NOT_SELECTED")
        delete segment.conditions_json.limit_to_landing_page_types

      $q (resolve, reject) ->
        Api.post("/api/projects/#{campaignSegment.project_id}/campaign_segments/mongo_query", {
          campaign_segment: segment
        }).then (res) ->
          resolve res.data.mongo_query

  new CampaignSegment(
    $resource
    $q
    "/api/projects/:projectId/campaign_segments/:id"
    "campaign_segment"
    "campaign_segments"
    { response: campaignSegmentResponseTransformer, request: campaignSegmentRequestTransformer}
  )

.factory "campaignSegmentRequestTransformer", ->

  doTransform = (elem) ->
    if elem.conditions_json.limit_to_landing_page_types &&
        elem.conditions_json.limit_to_landing_page_types.length &&
        elem.conditions_json.limit_to_landing_page_types[0] == 'NOT_SELECTED'
      elem.conditions_json.limit_to_landing_page_types[0] = ""
    elem

  (data) ->
    dataObj = _.merge {}, data
    if dataObj.campaign_segment
      dataObj.campaign_segment = doTransform(dataObj.campaign_segment)
    angular.toJson(dataObj)

.factory "campaignSegmentResponseTransformer", ->

  doTransform = (elem) ->
    raw = angular.fromJson(elem.raw)
    if raw
      elem.visitor = raw.visitor
      elem.session = raw.session

  (data) ->
    return if !data
    data = angular.fromJson(data)
    if data.campaign_segment
      doTransform(data.campaign_segment)
    else
      for campaign_segment in data.campaign_segments
        doTransform(campaign_segment)
    data



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/api/campaign_segment.service.coffee